// load tags
import './components/housingValueSPA/ahv-housing-value-spa.tag';
import './components/housingValueSearchBar/ahv-housing-value-search-bar.tag';
import './components/housingValueSearchBar/ahv-search-form.tag';
import './components/loginForm/ahv-login-form.tag';
import './components/housingValueDisplay/ahv-housing-value-display.tag';
import './components/housingValueDisplay/ahv-housing-value-display-header.tag';
import './components/cadastreDisplay/ahv-cadastre-display.tag';
import './components/buildingDisplay/ahv-building-display.tag';
import './components/ownershipDisplay/ahv-ownership-display.tag';
import './components/miscDisplay/ahv-misc-display.tag';
import './components/surroundingHousingValuesDisplay/ahv-surrounding-housing-values-display.tag';
import './components/mapDisplay/ahv-map-display.tag';
import './components/calculationBasis/ahv-calculation-basis.tag';
import './components/loadingIndicator/ahv-loading-indicator.tag';
import './components/helpDisplay/ahv-help-display.tag';
// load styles
import './styling/main.scss';
// mount entry tag
declare var riot;
riot.mount('ahv-housing-value-spa');



/** WEBPACK FOOTER **
 ** ./src/index.ts
 **/